"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import createFieldComponent from "../form-group/create-field-component.js";
import Input from "./input.js";
import PasswordInput from "./password-input.js";
import SearchInput from "./search-input.js";
export const PasswordInputField = createFieldComponent(PasswordInput);
export const SearchInputField = createFieldComponent(SearchInput);
export const TextInputField = createFieldComponent(Input);
export const InputField = React.forwardRef(function InputField(props, ref) {
    if (!props.multiline)
        switch (props.type) {
            case "password": {
                return _jsx(PasswordInputField, Object.assign({ ref: ref }, props));
            }
            case "search": {
                return _jsx(SearchInputField, Object.assign({ ref: ref }, props));
            }
            default: {
                return _jsx(TextInputField, Object.assign({ ref: ref }, props));
            }
        }
    else
        return _jsx(TextInputField, Object.assign({ ref: ref }, props));
});
export default InputField;
//# sourceMappingURL=input-field.js.map